<template lang="pug">
  .found-users__container
    template(
      v-for="user in foundUsers"
    )
      found-user(
        :user="user"
        :appName="appName"
        :clearSearchWord="clearSearchWord"
      )
</template>

<script>
import FoundUser from './FoundUser.vue';

export default {
  name: 'FoundUsersList',

  components: {
    FoundUser,
  },

  props: {
    foundUsers: {
      type: Array,
      required: true,
    },

    appName: {
      type: String,
      required: true,
    },

    clearSearchWord: {
      type: Function,
      required: true,
    },
  },

};
</script>

<style lang="scss" scoped>
  .found-users__container {
    border: solid 1px #cccccc;
    border-top: none;

    @include mobile {
      padding-top: 10px;
      padding-left: 17px;
      padding-right: 17px;
      padding-bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FoundUsersList.vue